module.exports = __webpack_public_path__ + "static/media/SevenSeg.82b3b572.glb";